import { backendApi } from "../dynamicBAseQuery";

export const clientsApi = backendApi.injectEndpoints({
    endpoints: (builder) => ({
        getGridDatas: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `client/list`,
                params: args
            })
        }),

        saveClient: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `Client/Save`,
                body: { ...args }
            })
        }),

        viewClientById: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `ViewClientById`,
                body: args
            })
        }),

        getClientContactById: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `getClientContactById`,
                body: { ...args }
            })
        }),

        saveClientContact: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `saveClientContact`,
                body: { ...args }
            })
        }),

        deleteTableDatas: builder.mutation({
            query: (args) => ({
                method: "DELETE",
                url: `deleteClientContact`,
                body: { ...args }
            })
        }),

        referralList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `client/referralList`,
                params: args
            })
        }),
        clientApproveAndReject: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `clientApproveAndReject`,
                params: args
            })
        }),
        RecruiterClientAndPosition: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `RecruiterClientAndPosition `,
                body: { ...args }
            })
        }),
        InternalReferralList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `client/InternalReferralList`,
                params: args
            })
        }),
        getReferralClientMailDesc: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `getReferralClientMailDesc`,
                body: { ...args }
            })
        }),
        sendEmailReferralClient: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `sendEmailReferralClient`,
                body: { ...args }
            })
        }),
        getMappedClient: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `getMappedClient`,
                body: { ...args }
            })
        }),
        saveClientCommission: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `saveClientCommission`,
                body: { ...args }
            })
        }),
         getClientCommissionList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `getClientCommissionList`,
                body: { ...args }
            })
        }),
         getClientCommission: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `getClientCommission`,
                body: { ...args }
            })
        }),
        
         updateClientCommissionStatus: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `updateClientCommissionStatus`,
                body: { ...args }
            })
        }),
    })
})

export const {
    useGetGridDatasMutation,
    useSaveClientMutation,
    useViewClientByIdMutation,
    useGetClientContactByIdMutation,
    useSaveClientContactMutation,
    useDeleteTableDatasMutation,
    useReferralListMutation,
    useClientApproveAndRejectMutation,
    useRecruiterClientAndPositionMutation,
    useInternalReferralListMutation,
    useGetReferralClientMailDescMutation,
    useSendEmailReferralClientMutation,
    useGetMappedClientMutation,
    useSaveClientCommissionMutation,
    useGetClientCommissionListMutation,
    useGetClientCommissionMutation,
    useUpdateClientCommissionStatusMutation,
} = clientsApi